import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import type { Testimonial } from '../data/testimonials';
type Props = {
  testimonial: Testimonial;
  delay?: number;
};
export function TestimonialCard({
  testimonial,
  delay = 0
}: Props) {
  return <motion.figure initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.3,
    delay,
    ease: [0.23, 1, 0.32, 1]
  }} className="flex flex-col rounded-2xl border border-grape-soft/40 bg-white p-5 shadow-[0_12px_30px_-24px_rgba(0,0,0,0.4)]" data-id="element-288" data-mp="2p7g9druzygnj">
      <figcaption className="flex items-center gap-3" data-id="element-289" data-mp="344pdlm5efewo">
        <img src={testimonial.img} alt={testimonial.name} width={52} height={52} loading="lazy" decoding="async" className="h-13 w-13 h-[52px] w-[52px] shrink-0 rounded-full object-cover ring-2 ring-grape-soft" data-id="element-290" data-mp="3434jtyqwrzzv" />
        <div className="min-w-0" data-id="element-291" data-mp="1dsjiecf95hdj">
          <div className="flex flex-wrap items-center gap-x-2 gap-y-0.5" data-id="element-292" data-mp="1dtksoeog1zu7">
            <span className="text-sm font-bold text-plum" data-id="element-293" data-mp="hsks4v80pq6q">{testimonial.name}</span>
            <span className="flex gap-0.5 text-grape-soft" aria-label="5 out of 5 stars" data-id="element-294" data-mp="d24cr5kmzuhq">
              {Array.from({
              length: 5
            }).map((_, k) => <StarIcon key={k} className="h-3.5 w-3.5 fill-current" data-id="element-295" data-mp="828957fuq52p" data-mpi={k} />)}
            </span>
          </div>
          <p className="text-xs font-semibold text-grape" data-id="element-296" data-mp="34znuxzepkx8">{testimonial.role}</p>
          <div className="flex items-center gap-1.5 text-xs text-plum/55" data-id="element-297" data-mp="10s8flaq03q7o">
            <span data-id="element-298" data-mp="10pcejdiuwlf0">📍 {testimonial.location}</span>
            <span className="text-sm leading-none" aria-hidden="true" data-id="element-299" data-mp="vtnbv1bjioeh">{testimonial.flag}</span>
          </div>
        </div>
      </figcaption>
      <blockquote className="mt-4 flex-1 border-t border-grape-soft/30 pt-3 text-[15px] leading-relaxed text-plum/75" data-id="element-300" data-mp="qvc54zgjku0h">
        “{testimonial.quote}”
      </blockquote>
    </motion.figure>;
}